module.exports = __webpack_public_path__ + "media/newstyle/images/medium-shot-excited-woman-with-laptop-2-40eb08817fac49f511c75a19a7714e14.png";